import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "form"]
  static values = { url: String }

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.engagementCompletionUrlValue ||
                event.currentTarget.dataset.url
    if (url && this.hasFormTarget) {
      this.formTarget.action = url
    }
    this.modalTarget.classList.remove("hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }

  submit(event) {
    event.preventDefault()
    this.formTarget.submit()
  }
}
